import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, KeepAlive as _KeepAlive, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/imgs/logo/logo1.png';
import _imports_1 from '../../assets/imgs/button/button20.png';
import _imports_2 from '../../assets/imgs/button/button9.png';
import _imports_3 from '../../assets/imgs/button/button21.png';
import _imports_4 from '../../assets/imgs/image/image1.png';
const _withScopeId = n => (_pushScopeId("data-v-74e94796"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "wrapp"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "layout_header flex_FSBC"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0
})], -1));
const _hoisted_3 = {
  class: "wrapp flex"
};
const _hoisted_4 = {
  class: "left_bar"
};
const _hoisted_5 = {
  class: "mine_info"
};
const _hoisted_6 = {
  class: "mt35 mine_info_btn _outline mb15"
};
const _hoisted_7 = {
  class: "mine_info_btn _outline flex_FSBC mb10"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "mr10"
}, "个人中心", -1));
const _hoisted_9 = {
  key: 0,
  class: "mine_info_btn_s1",
  src: _imports_1
};
const _hoisted_10 = {
  key: 1,
  class: "mine_info_btn_s2",
  src: _imports_2
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = ["src"];
const _hoisted_13 = {
  class: "ml10"
};
const _hoisted_14 = {
  class: "flex_FSC"
};
const _hoisted_15 = ["src"];
const _hoisted_16 = {
  key: 0,
  class: "menu-item-s",
  src: _imports_1
};
const _hoisted_17 = {
  key: 1,
  class: "menu-item-s",
  src: _imports_3
};
const _hoisted_18 = {
  class: "layout_main"
};
const _hoisted_19 = {
  key: 0,
  class: "startup"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "startup_img",
  src: _imports_4,
  alt: ""
}, null, -1));
const _hoisted_21 = [_hoisted_20];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_menu_item = _resolveComponent("el-menu-item");
  const _component_el_menu = _resolveComponent("el-menu");
  const _component_el_aside = _resolveComponent("el-aside");
  const _component_router_view = _resolveComponent("router-view");
  const _component_TLoading = _resolveComponent("TLoading");
  const _component_el_config_provider = _resolveComponent("el-config-provider");
  return _openBlock(), _createBlock(_component_el_config_provider, {
    locale: $setup.zhCn
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString($setup.isPhoneNumber($setup.mainStore.userInfo?.nickName) ? $setup.phoneDesc($setup.mainStore.userInfo?.nickName) : $setup.EncryptName($setup.mainStore.userInfo?.nickName)), 1), _createElementVNode("div", _hoisted_7, [_createElementVNode("p", {
      class: _normalizeClass(['flex_size_1', $setup.AuthTypeMap[$setup.data.identityAuth.toString()].type]),
      style: {
        "border-radius": "0.5208vw",
        "border-right": "solid 0.1042vw #c9caca"
      }
    }, " 身份" + _toDisplayString($setup.AuthTypeMap[$setup.data.identityAuth.toString()].label), 3), _createElementVNode("p", {
      class: _normalizeClass(['flex_size_1', $setup.AuthTypeMap[$setup.data.companyAuth.toString()].type])
    }, " 企业" + _toDisplayString($setup.AuthTypeMap[$setup.data.companyAuth.toString()].label), 3)]), _createElementVNode("div", {
      class: _normalizeClass(['mt5 mine_info_btn _outline pointer flex_FCAC', $setup.data.isExpend && 'active']),
      onClick: _cache[0] || (_cache[0] = (...args) => $setup.setIsExpend && $setup.setIsExpend(...args))
    }, [_hoisted_8, $setup.data.isExpend ? (_openBlock(), _createElementBlock("img", _hoisted_9)) : (_openBlock(), _createElementBlock("img", _hoisted_10))], 2), _createElementVNode("ul", {
      class: _normalizeClass(['personal_center', !$setup.data.isExpend && '_hidden'])
    }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.personList, (item, index) => {
      return _openBlock(), _createElementBlock("li", {
        class: _normalizeClass(['flex_FSC ml10 mr10 mt10 pointer pl10 pr10 pt5 pb5', index == $setup.data.personListIndex && 'person_active']),
        key: index,
        onClick: () => $setup.setPersonListIndex(index, item.src)
      }, [_createElementVNode("img", {
        src: index == $setup.data.personListIndex ? item.active : item.default
      }, null, 8, _hoisted_12), _createElementVNode("p", _hoisted_13, _toDisplayString(item.label), 1)], 10, _hoisted_11);
    }), 128))], 2), _createElementVNode("div", {
      class: "mt10 mb50 mine_info_btn _outline pointer",
      onClick: _cache[1] || (_cache[1] = (...args) => $setup.logout && $setup.logout(...args))
    }, " 退出登录 ")]), _createVNode(_component_el_aside, {
      width: "15vw"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_menu, {
        "default-active": $setup.mainStore.tabIndex.toString(),
        onSelect: $setup.handlesSelectMenu
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.menuBar, (item, index) => {
          return _openBlock(), _createBlock(_component_el_menu_item, {
            class: "flex_FSBC",
            key: index,
            index: index.toString()
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_14, [_createElementVNode("img", {
              class: "el-menu-item-icon",
              src: $setup.mainStore.tabIndex == index ? item.active : item.default
            }, null, 8, _hoisted_15), _createElementVNode("span", null, _toDisplayString(item.name), 1)]), $setup.mainStore.tabIndex == index ? (_openBlock(), _createElementBlock("img", _hoisted_16)) : (_openBlock(), _createElementBlock("img", _hoisted_17))]),
            _: 2
          }, 1032, ["index"]);
        }), 128))]),
        _: 1
      }, 8, ["default-active", "onSelect"])]),
      _: 1
    })]), _createElementVNode("div", _hoisted_18, [_createVNode(_component_TLoading, {
      loading: $setup.mainStore.globalLoading
    }, {
      default: _withCtx(() => [_createVNode(_Transition, {
        name: "opacity"
      }, {
        default: _withCtx(() => [(_openBlock(), _createBlock(_KeepAlive, null, [_createVNode(_component_router_view)], 1024))]),
        _: 1
      })]),
      _: 1
    }, 8, ["loading"])])])]), $setup.data.isViewStartUp ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21)) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["locale"]);
}